import axios from 'axios';

const baseURL = process.env.BASE_URL;

const api = axios.create({baseURL});

// SEARCH ENDPOINTS
let searchRequest;

const createSearchRequest = (query) => {
  let request = `${process.env.SEARCH_URL}/query?q=${query}&type=player`;
  if (searchRequest) {
    searchRequest.cancel('Only one request allowed at a time.');
  }
  searchRequest = axios.CancelToken.source();
  return api.get(request, {cancelToken: searchRequest.token}).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled:', thrown.message);
    }
  });
};

const getSearch = (query) => createSearchRequest(query);

const getTopEleven = (id) => {
  return api.get(`/eleven/${id}`);
};

const putTopEleven = (id, data) => {
  return api.put(`/admin/eleven/${id}`, data);
};

export {getSearch, getTopEleven, putTopEleven};
